import styled from 'styled-components'

import theme from 'theme_'

export const PaymentMethodsPageWrapper = styled.div`
  margin: ${theme.spacing.lg} ${theme.spacing.sm} ${theme.spacing.lg};
`

export const PaymentMethodsHeading = styled.div`
  margin-bottom: ${theme.spacing.base};
`

export const AddPamentMethodButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${theme.spacing.md};

  @media ${theme.devices.tablet} {
    justify-content: flex-end;
  }
`

export const PaymentMethodsPageSubTitle = styled.div`
  color: ${theme.colors.moreGrey};
`
